var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    rx: 15.333,
    fill: "#BDD5FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.268 24.628H13.732c-1.15 0-1.585-.69-1.718-.98-.133-.29-.363-1.077.388-1.948l8.892-10.176c.871-.99 2.54-.99 3.412 0l8.88 10.176c.763.87.533 1.657.4 1.948-.133.29-.569.98-1.718.98zM13.732 26.67h18.536a2.42 2.42 0 0 1 2.42 2.42v3.629c0 1.33-1.09 2.42-2.42 2.42H13.732a2.427 2.427 0 0 1-2.42-2.42v-3.63a2.42 2.42 0 0 1 2.42-2.42z",
    fill: "#1175D4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeOpen);
export default __webpack_public_path__ + "static/media/homeOpen.0a1ff419f61a0ef5d3edf8e4c81c0713.svg";
export { ForwardRef as ReactComponent };